// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-btn {
  background: #000;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 15px;
  bottom: -100%;
  opacity: 0;
  animation: smooth-appear 1s ease forwards;
}
.menu-btn ion-icon {
  height: 30px;
  width: 30px;
  color: #fff;
}

@keyframes smooth-appear {
  to {
    bottom: 10px;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAEA;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACG,uBAAA;EACA,mBAAA;EACH,eAAA;EACG,UAAA;EACH,aAAA;EACE,UAAA;EACF,yCAAA;AADD;AAEC;EACI,YAAA;EACA,WAAA;EACA,WAAA;AAAL;;AAGA;EACE;IACE,YAAA;IACA,UAAA;EAAF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.menu-btn {\n\tbackground: #000;\n\tborder-radius: 50%;\n\twidth: 50px;\n\theight: 50px;\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\tposition: fixed;\n    left: 15px;\n\tbottom: -100%;\n  \topacity:0;\n\tanimation: smooth-appear 1s ease forwards;\n\tion-icon {\n\t    height: 30px;\n    \twidth: 30px;\n    \tcolor: #fff;\n\t}\n}\n@keyframes smooth-appear {\n  to{\n    bottom: 10px;\n    opacity:1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
